export enum WeblogPageCategory {
  MAIN = '홈',
  ACCOMMODATION_MAIN = '숙소홈',
  ACCOMMODATION_DETAIL = '국내숙소 상세',
  LODGING_MAIN = '감성숙소 메인',
  LODGING_LIST = '감성숙소 리스트',
  LODGING_DETAIL = '감성숙소 상세',
  LODGING_OPTION = '감성숙소 객실상세 진입',
  RENTACAR_MAIN = '렌터카 홈',
  RENTACAR_LIST = '렌터카 리스트',
  RENTACAR_DETAIL = '렌터카 상세',
  RENTACAR_MAP = '렌터카 지도',
  PURCHASE_NEW = '3.0 예약화면',
  PURCHASE_COMPLETE_NEW = '3.0 예약완료 화면',
  RESERVATION_HISTORY_ONGOING = '예약내역 (예정된 여행)',
  RESERVATION_HISTORY_VOUCHER = '예약내역 (티켓/패스)',
  RESERVATION_HISTORY_FLIGHT = '예약내역 (항공권)',
  RESERVATION_HISTORY_FINISH = '예약내역 (지난 여행)',
  RESERVATION_HISTORY_CANCEL = '예약내역 (취소된 여행)',
  CHECKOUT = '체크아웃 주문하기',
  CHECKOUT_COMPLETE = '체크아웃 주문 완료',
  CHECKOUT_PAYMENT_FAILED = '체크아웃 결제 실패',
  CHECKOUT_RESERVATION_FAILED = '체크아웃 예약 실패',
  CHECKOUT_RESERVATION_DETAIL = '체크아웃 예약 상세',
  CHECKOUT_RESERVATION_DETAIL_CANCEL = '체크아웃 > 예약 상세 > 예약 취소 모달',
  CHECKOUT_RESERVATION_DETAIL_CANCEL_POPUP = '체크아웃 > 예약 상세 > 예약 취소 모달 > 예약 취소 클릭 > 확인 팝업',
  CHECKOUT_RESERVATION_DETAIL_REQUEST_CANCEL = '체크아웃 > 예약 상세 > 취소 요청 모달',
  CHECKOUT_RESERVATION_DETAIL_REQUEST_CANCEL_POPUP = '체크아웃 > 예약 상세 > 취소 요청 모달 > 취소 요청 클릭 > 확인 팝업',
  REVIEW_REGISTER = '후기 플랫폼 후기 작성',
  REVIEW_MODIFY = '후기 플랫폼 후기 수정',
  PROMOTION_LIST = '프로모션 리스트',
  PROMOTION_DETAIL = '프로모션 상세',
  OFFER_DETAIL = '상품 상세',
  EVENT_DGM = '대국민 숙박대전 이벤트',
  CITY = '도시 페이지',
  COMMON = '공통',
  SIGNIN = '로그인',
  SIGNUP = '회원가입',
  EMAIL_SIGNIN = '이메일 로그인',
  EMAIL_SIGNUP = '이메일 회원가입',
}

export enum WeblogScreenName {
  MAIN = 'main',
  ACCOMMODATION_MAIN = 'accommodation_main',
  ACCOMMODATION_DETAIL = 'accommodation_detail',
  LODGING_MAIN = 'lodging_main',
  LODGING_LIST = 'lodging_list',
  LODGING_DETAIL = 'lodging_detail',
  LODGING_OPTION = 'lodging_option',
  RENTACAR_MAIN = 'rentacar_main',
  RENTACAR_LIST = 'rentacar_list',
  RENTACAR_DETAIL = 'rentacar_detail',
  RENTACAR_MAP = 'rentacar_map',
  PURCHASE_NEW = 'purchase_new',
  PURCHASE_COMPLETE_NEW = 'purchase_complete_new',
  RESERVATION_HISTORY_ONGOING = 'reservation_history_ongoing',
  RESERVATION_HISTORY_VOUCHER = 'reservation_history_voucher',
  RESERVATION_HISTORY_FLIGHT = 'reservation_history_flight',
  RESERVATION_HISTORY_FINISH = 'reservation_history_finish',
  RESERVATION_HISTORY_CANCEL = 'reservation_history_cancel',
  CHECKOUT = 'checkout',
  CHECKOUT_COMPLETE = 'checkout_complete',
  CHECKOUT_PAYMENT_FAILED = 'checkout_payment_failed',
  CHECKOUT_RESERVATION_FAILED = 'checkout_reservation_failed',
  CHECKOUT_RESERVATION_DETAIL = 'checkout_reservation_detail',
  CHECKOUT_RESERVATION_DETAIL_CANCEL = 'checkout_reservation_detail_cancel',
  CHECKOUT_RESERVATION_DETAIL_CANCEL_POPUP = 'checkout_reservation_detail_cancel_popup',
  CHECKOUT_RESERVATION_DETAIL_REQUEST_CANCEL = 'checkout_reservation_detail_request_cancel',
  CHECKOUT_RESERVATION_DETAIL_REQUEST_CANCEL_POPUP = 'checkout_reservation_detail_request_cancel_popup',
  REVIEW_REGISTER = 'review_register',
  REVIEW_MODIFY = 'review_modify',
  PROMOTION_LIST = 'promotion_list',
  PROMOTION_DETAIL = 'promotion_detail',
  OFFER_DETAIL = 'offer_detail',
  EVENT_DGM = 'campaign_dgm',
  CITY = 'city',
  COMMON = 'common',
  SIGNIN = 'login',
  SIGNUP = 'signup',
  EMAIL_SIGNIN = 'email_signin',
  EMAIL_SIGNUP = 'email_signup',
}

export enum WeblogEventName {
  CANCEL_BUTTON = 'cancel_button',
  REQUEST_CANCEL_BUTTON = 'request_cancel_button',
  CANCEL_POPUP = 'cancel_popup',
  REQUEST_CANCEL_POPUP = 'request_cancel_popup',
  REVIEW_MODIFY = 'review_modify',
  REVIEW_DELETE = 'review_delete',
  REVIEW_DELETE_OK = 'review_delete_ok',
  RESERVATION_DETAIL = 'reservation_detail',
  CANCEL_CHECK_POPUP_BUTTON = 'cancel_check_popup_button',
  REQUEST_CANCEL_CHECK_POPUP_BUTTON = 'request_cancel_check_popup_button',
}
